import React from 'react';
import { Mail, Phone } from 'lucide-react';
import StaticPage from './StaticPage';

export default function Contact() {
  return (
    <StaticPage
      title="Contact ALFÀ"
      subtitle="Reach out with questions about your plan, our providers, or your order."
      seoDescription="Contact ALFÀ Health — email help@alfameds.com or call 941-948-9940. Questions about your account, orders, or care."
    >
      <div className="not-prose grid sm:grid-cols-2 gap-4 mt-4">
        <a
          href="mailto:help@alfameds.com"
          data-testid="contact-email-link"
          className="group rounded-lg border border-neutral-900/10 bg-white/70 backdrop-blur p-6 sm:p-7 hover:shadow-xl transition-shadow flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-md bg-neutral-950 text-white flex items-center justify-center flex-shrink-0">
            <Mail size={20} strokeWidth={1.75} />
          </div>
          <div>
            <p className="uppercase text-[12px] tracking-[0.2em] text-neutral-950 font-semibold">Email</p>
            <p className="mt-1 font-display uppercase text-[20px] text-neutral-950 tracking-[-0.01em] break-all">
              help@alfameds.com
            </p>
            <p className="mt-2 text-[14px] text-neutral-950">
              For account, prescription, or refill questions.
            </p>
          </div>
        </a>

        <a
          href="tel:+19419489940"
          data-testid="contact-phone-link"
          className="group rounded-lg border border-neutral-900/10 bg-white/70 backdrop-blur p-6 sm:p-7 hover:shadow-xl transition-shadow flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-md bg-neutral-950 text-white flex items-center justify-center flex-shrink-0">
            <Phone size={20} strokeWidth={1.75} />
          </div>
          <div>
            <p className="uppercase text-[12px] tracking-[0.2em] text-neutral-950 font-semibold">Phone</p>
            <p className="mt-1 font-display uppercase text-[20px] text-neutral-950 tracking-[-0.01em]">
              941&nbsp;·&nbsp;948&nbsp;·&nbsp;9940
            </p>
            <p className="mt-2 text-[14px] text-neutral-950">
              Talk to a real person, Monday–Friday, 9am–6pm ET. Leave a voicemail anytime.
            </p>
          </div>
        </a>
      </div>

      <h2 className="mt-14">What to expect</h2>
      <p>
        An ALFÀ team member reviews each message. If your question is
        clinical (dosing, side effects, whether to switch programs), we route it to a licensed
        provider on our care team. If it's about billing, shipping, or account access, our
        support team will follow up.
      </p>

      <h2>For urgent or emergency issues</h2>
      <p>
        If you are experiencing a medical emergency, please call <strong>911</strong> or go to
        the nearest emergency room. ALFÀ does not provide emergency medical services and our
        support hours may not match your time zone.
      </p>

      <h2>Media & partnerships</h2>
      <p>
        For press inquiries, retail partnerships, or clinical collaborations, email{' '}
        <a className="underline" href="mailto:help@alfameds.com">help@alfameds.com</a> with
        "Partnerships" in the subject line and someone from the leadership team will get back to
        you within a few business days.
      </p>
    </StaticPage>
  );
}
